<div class="context-component-wrapper">
	<div class="num-wrapper">
		<div>{{selected.length}}</div>
        <div class="label-num">{{'scn' | translate}}</div>
	</div>
	<div class="buttons-menu">
		<div class="button-action" [ngClass]="{'disable': selected.length <= 0}" (click)="selected.length <= 0 ? null : edit()">
			<a mat-icon-button aria-label="edit">
                <span class="material-icons filter-btn">edit</span>
			</a>
			<span>{{'Edit' | translate}}</span>
		</div>
		<div class="button-action" [ngClass]="{'disable': (selected.length <= 0)}" (click)="selected.length <= 0 ? null : cancel()">
			<a mat-icon-button aria-label="edit">
                <span class="material-icons filter-btn">block</span>
			</a>
			<span>{{'Cancel' | translate}}</span>
		</div>
		<div class="button-action" [ngClass]="{'disable': selected.length <= 0 || scenesCannotBeDeleted()}" (click)="selected.length <= 0 ? null : delete()">
			<a mat-icon-button aria-label="edit">
                <span class="material-icons filter-btn">delete</span>
			</a>
			<span>{{'Delete' | translate}}</span>
		</div>
	</div>
	<div class="wrapper-close" (click)="close()">
        <span class="material-icons filter-btn">close</span>
	</div>
</div>